<template>
  <div id="sellerShippingTariffsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-truck-field fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">تعرفه حمل و نقل و اطلاعات حساب</span>
                </div>
              </div>
              <div class="col-8 text-center font-weight-bold">
                <span :class="accountInfoTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showAccountInfoTab">اطلاعات حساب و تماس خرید آفلاین</span>
              </div>
              <div class="col-4 text-center font-weight-bold pr-0">
                <span :class="shippingTariffsTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showShippingTariffsTab">تعرفه های بارگیری</span>
              </div>
            </div>
            <div v-if="accountInfoTab" class="row">
              <div class="col-12">
                <div class="font-weight-bold mb-2 mr-2">شماره حساب یا کارت</div>
                <v-text-field
                    v-model="card1"
                    flat
                    hide-details
                    placeholder="شماره حساب یا کارت"
                    solo>

                </v-text-field>
                <v-text-field
                    v-model="card2"
                    class="my-2"
                    flat
                    hide-details
                    placeholder="شماره حساب یا کارت"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="card3"
                    flat
                    hide-details
                    placeholder="شماره حساب یا کارت"
                    solo>
                </v-text-field>
                <v-checkbox v-model="isCardActive">
                  <template slot="label">
                    <div class="font12px font-weight-bold">
                      نمایش در پروفایل
                    </div>

                  </template>
                </v-checkbox>
              </div>
              <div class="col-12">
                <div class="font-weight-bold mb-2 mr-2">شماره تماس جهت سفارش</div>
                <v-text-field
                    v-model="tel1"
                    flat
                    hide-details
                    placeholder="شماره تماس 1"
                    solo>

                </v-text-field>
                <v-text-field
                    v-model="tel2"
                    class="my-2"
                    flat
                    hide-details
                    placeholder="شماره تماس 2"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="tel3"
                    flat
                    hide-details
                    placeholder="شماره تماس 3"
                    solo>
                </v-text-field>
                <v-checkbox
                    v-model="isTelActive">
                  <template slot="label">
                    <div class="font12px font-weight-bold">
                      نمایش در پروفایل
                    </div>

                  </template>
                </v-checkbox>
              </div>
              <div class="col-12">
                <div class="font-weight-bold mb-2 mr-2">شماره واتس اپ</div>
                <v-text-field
                    v-model="whatsapp1"
                    flat
                    hide-details
                    placeholder="شماره واتس اپ 1"
                    solo>

                </v-text-field>
                <v-text-field
                    v-model="whatsapp2"
                    class="my-2"
                    flat
                    hide-details
                    placeholder="شماره واتس اپ 2"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="whatsapp3"
                    flat
                    hide-details
                    placeholder="شماره واتس اپ 3"
                    solo>
                </v-text-field>
                <v-checkbox
                    v-model="isWhatsappActive">
                  <template slot="label">
                    <div class="font12px font-weight-bold">
                      نمایش در پروفایل
                    </div>

                  </template>
                </v-checkbox>
              </div>
              <div class="col-12">
                <div class="font-weight-bold mb-2 mr-2">شماره تلگرام</div>
                <v-text-field
                    v-model="tlg1"
                    flat
                    hide-details
                    placeholder="شماره تلگرام 1"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="tlg2"
                    class="my-2"
                    flat
                    hide-details
                    placeholder="شماره تلگرام 2"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="tlg3"
                    flat
                    hide-details
                    placeholder="شماره تلگرام 3"
                    solo>
                </v-text-field>
                <v-checkbox
                    v-model="isTlgActive">
                  <template slot="label">
                    <div class="font12px font-weight-bold">
                      نمایش در پروفایل
                    </div>
                  </template>
                </v-checkbox>
              </div>
              <div class="col-12">
                <div class="font-weight-bold mb-2 mr-2">آیدی اینستاگرام بدون @</div>
                <v-text-field
                    v-model="social1"
                    flat
                    hide-details
                    placeholder="آیدی 1"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="social2"
                    class="my-2"
                    flat
                    hide-details
                    placeholder="آیدی 2"
                    solo>
                </v-text-field>
                <v-text-field
                    v-model="social3"
                    flat
                    hide-details
                    placeholder="آیدی 3"
                    solo>
                </v-text-field>
                <v-checkbox
                    v-model="isSocialActive">
                  <template slot="label">
                    <div class="font12px font-weight-bold">
                      نمایش در پروفایل
                    </div>
                  </template>
                </v-checkbox>
              </div>
              <div class="col-12">
                <v-btn block color="primary" @click="editInfo">
                  ثبت
                </v-btn>
              </div>
            </div>
            <div v-if="shippingTariffsTab" class="row">
              <div class="col-12 text-center">
                <div class="font-weight-bold mt-2">ارسال بار هوشمند</div>
                <div class="font-weight-bold mt-1">پیام ایوان خانه به فروشندگان محترم</div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div>
                  <i class="fa-solid fa-period mr-3"></i>
                  <span class="font-weight-bold font12px"> تعرفه ها درون شهری هستند(یعنی خریدار و فروشنده در یک <span
                      class="text-decoration-underline red--text font12px">یک شهر</span> هستند)</span>
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div class="mr-3">
                  <i class="fa-solid fa-period "></i>
                  <span class="font-weight-bold font12px"> اگر امکان ارسال با شیوه های ذکر شده را ندارید آن را  <span
                      class="text-decoration-underline red--text font12px">غیرفعال</span> نمایید تا برای مشتری نمایش داده نشود</span>
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div class="mr-3">
                  <i class="fa-solid fa-period "></i>
                  <span class="font-weight-bold font12px pr-1">در قیمت گذاری تعرفه ها دقت کنید چون در فاکتور برای مشتری جهت پرداخت لحاظ میگردد لذا مسئولیت کم یا زیاد بودن بر عهده فروشنده میباشد.</span>
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div class="mr-3">
                  <i class="fa-solid fa-period "></i>
                  <span class="font-weight-bold font12px pr-1">برای اینکه هزینه حمل بر    <span
                      class="text-decoration-underline red--text font12px"> عهده خریدار </span>  باشد کلیه آیتم های زیر را غیرفعال نمایید .</span>
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div>
                  <i class="fa-solid fa-period mr-3"></i>
                  <span class="font-weight-bold font12px pr-1">در قیمت ها باید <span
                      class="text-decoration-underline red--text font12px"> میانگبن </span> قیمت را برای هر ماشین در نظر بگیرند.</span>
                </div>
                <div class="font12px text-color mt-1">( مثلا هزینه پیک از فروشگاه شما تا مسافت نزدیک ودور یک مبلغ
                  میانگین در نظر بگیرید به طور مثال 35.000 تومان )
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div class="mr-3">
                  <i class="fa-solid fa-period "></i>
                  <span class="font-weight-bold font12px pr-1">برای    <span
                      class="text-decoration-underline red--text font12px"> رایگان </span>  بودن هزینه حمل عدد "0" وارد نمایید.</span>
                </div>
              </div>
              <div class="col-12 pl-0 py-0">
                <div class="mr-3">
                  <i class="fa-solid fa-period "></i>
                  <span class="font-weight-bold font12px pr-1">قیمت ها را    <span
                      class="text-decoration-underline red--text font12px">تومان </span>  وارد نمایید.</span>
                </div>
              </div>
              <div class="col-12 mt-4">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="fas fa-motorcycle transform-icon ml-1 font16px "></i> پیک موتوری</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByMotor" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByMotor">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="far fa-wagon-covered transform-icon ml-1 font16px "></i>وانت سبک</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByVanetSabok" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByVanetSabok">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="far fa-truck-pickup transform-icon ml-1 font16px "></i>وانت سنگین</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByVanetSangin" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveVanetSangin">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="far fa-truck-container transform-icon ml-1 font16px "></i>خاورمسقف</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByKhavarMamuli" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByKhavarMamuli">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="fas fa-truck transform-icon ml-1 font16px "></i>خاور بزرگ</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByKhavarBozorg" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByKhavarBozorg">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="far fa-truck transform-icon ml-1 font16px "></i>ایسوزو</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByIsuzu" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByIsuzu">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="fas fa-truck-container transform-icon ml-1 font16px "></i>کامیون معمولی</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByKainunMamuli" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByKainunMamuli">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="fas fa-truck-field transform-icon ml-1 font16px "></i>کامیون تک</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByKainunTak" dense flat hide-details
                                solo>

                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByKainunTak">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>

                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12 pt-0">
                  <span class=" primary-text font-weight-bold mr-2"><i
                      class="far fa-truck-field transform-icon ml-1 font16px "></i>کامیون جفت</span>
                <div class="mt-3">
                  <v-text-field v-model="sendByKainunJoft" dense flat hide-details
                                solo>
                  </v-text-field>
                  <v-checkbox
                      v-model="isActiveSendByKainunJoft">
                    <template slot="label">
                      <div class="font12px font-weight-bold">
                        نمایش در پروفایل و فاکتور
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
              <div class="col-12">
                <v-btn block color="primary" @click="setShippingData">
                  ثبت
                </v-btn>
              </div>

            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "SellerShippingTariffs",
  metaInfo: {
    title: 'ایوان خانه- تعرفه حمل و نقل و اطلاعات حساب',
  },
  components: {BackBar},
  data: () => ({
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    accountInfoTab: true,
    shippingTariffsTab: false,
    card1: '',
    card2: '',
    card3: '',
    isCardActive: false,
    tel1: '',
    tel2: '',
    tel3: '',
    isTelActive: false,
    whatsapp1: '',
    whatsapp2: '',
    whatsapp3: '',
    isWhatsappActive: false,
    tlg1: '',
    tlg2: '',
    tlg3: '',
    isTlgActive: false,
    social1: '',
    social2: '',
    social3: '',
    isSocialActive: false,
    sendByMotor: '',
    sendByVanetSabok: '',
    sendByVanetSangin: '',
    sendByIsuzu: '',
    sendByKhavarMamuli: '',
    sendByKhavarBozorg: '',
    sendByKainunMamuli: '',
    sendByKainunTak: '',
    sendByKainunJoft: '',
    isActiveSendByMotor: false,
    isActiveSendByVanetSabok: false,
    isActiveVanetSangin: false,
    isActiveSendByIsuzu: false,
    isActiveSendByKhavarMamuli: false,
    isActiveSendByKhavarBozorg: false,
    isActiveSendByKainunMamuli: false,
    isActiveSendByKainunTak: false,
    isActiveSendByKainunJoft: false,
  }),
  mounted() {
    this.getInfo()
    this.getShippingData()
  },
  methods: {
    showAccountInfoTab() {
      this.accountInfoTab = true;
      this.shippingTariffsTab = false
    },
    showShippingTariffsTab() {
      this.accountInfoTab = false;
      this.shippingTariffsTab = true
    },
    getInfo() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorInformationManagement/_DefineEditInfo", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.card1 = json.CardOne === null ? '' : json.CardOne
            this.card2 = json.CardTwo === null ? '' : json.CardTwo
            this.card3 = json.CardThree === null ? '' : json.CardThree
            this.isCardActive = json.IsActiveCard
            this.tel1 = json.PhoneOne === null ? '' : json.PhoneOne
            this.tel2 = json.PhoneTwo === null ? '' : json.PhoneTwo
            this.tel3 = json.PhoneThree === null ? '' : json.PhoneThree
            this.isTelActive = json.IsActivePhone
            this.whatsapp1 = json.PhoneWhatsappOne === null ? '' : json.PhoneWhatsappOne
            this.whatsapp2 = json.PhoneWhatsappTwo === null ? '' : json.PhoneWhatsappTwo
            this.whatsapp3 = json.PhoneWhatsappThree === null ? '' : json.PhoneWhatsappThree
            this.isWhatsappActive = json.IsActiveWhatsapp
            this.tlg1 = json.PhoneTelegramOne === null ? '' : json.PhoneTelegramOne
            this.tlg2 = json.PhoneTelegramTwo === null ? '' : json.PhoneTelegramTwo
            this.tlg3 = json.PhoneTelegramThree === null ? '' : json.PhoneTelegramThree
            this.isTlgActive = json.IsActiveTelegram
            this.social1 = json.LinkOne === null ? '' : json.LinkOne
            this.social2 = json.LinkTwo === null ? '' : json.LinkTwo
            this.social3 = json.LinkThree === null ? '' : json.LinkThree
            this.isSocialActive = json.IsActiveLink
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    editInfo() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("IsActiveCard", this.isCardActive);
      urlencoded.append("IsActivePhone", this.isTelActive);
      urlencoded.append("IsActiveWhatsapp", this.isWhatsappActive);
      urlencoded.append("IsActiveTelegram", this.isTlgActive);
      urlencoded.append("IsActiveLink", this.isSocialActive);
      urlencoded.append("CardOne", this.card1);
      urlencoded.append("CardTwo", this.card2);
      urlencoded.append("CardThree", this.card3);
      urlencoded.append("PhoneOne", this.tel1);
      urlencoded.append("PhoneTwo", this.tel2);
      urlencoded.append("PhoneThree", this.tel3);
      urlencoded.append("PhoneWhatsappOne", this.whatsapp1);
      urlencoded.append("PhoneWhatsappTwo", this.whatsapp2);
      urlencoded.append("PhoneWhatsappThree", this.whatsapp3);
      urlencoded.append("PhoneTelegramOne", this.tlg1);
      urlencoded.append("PhoneTelegramTwo", this.tlg2);
      urlencoded.append("PhoneTelegramThree", this.tlg3);
      urlencoded.append("LinkOne", this.social1);
      urlencoded.append("LinkTwo", this.social2);
      urlencoded.append("LinkThree", this.social3);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/VendorInformationManagement/_DefineEditInfo", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.resultText = JSON.parse(result).Message
            } else {
              this.resultText = result
            }
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    getShippingData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VendorInformationManagement/_DefineEditTransport", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.isActiveSendByMotor = json.IsActiveSendByMotor;
            this.isActiveSendByVanetSabok = json.IsActiveSendByVanetSabok;
            this.isActiveVanetSangin = json.IsActiveVanetSangin;
            this.isActiveSendByIsuzu = json.IsActiveSendByIsuzu;
            this.isActiveSendByKhavarMamuli = json.IsActiveSendByKhavarMamuli;
            this.isActiveSendByKhavarBozorg = json.IsActiveSendByKhavarBozorg;
            this.isActiveSendByKainunMamuli = json.IsActiveSendByKainunMamuli;
            this.isActiveSendByKainunTak = json.IsActiveSendByKainunTak;
            this.isActiveSendByKainunJoft = json.IsActiveSendByKainunJoft;
            this.sendByMotor = json.SendByMotor === null ? '' : json.SendByMotor
            this.sendByVanetSabok = json.SendByVanetSabok === null ? '' : json.SendByVanetSabok
            this.sendByVanetSangin = json.SendByVanetSangin === null ? '' : json.SendByVanetSangin
            this.sendByIsuzu = json.SendByIsuzu === null ? '' : json.SendByIsuzu
            this.sendByKhavarMamuli = json.SendByKhavarMamuli === null ? '' : json.SendByKhavarMamuli
            this.sendByKhavarBozorg = json.SendByKhavarBozorg === null ? '' : json.SendByKhavarBozorg
            this.sendByKainunMamuli = json.SendByKainunMamuli === null ? '' : json.SendByKainunMamuli
            this.sendByKainunTak = json.SendByKainunTak === null ? '' : json.SendByKainunTak
            this.sendByKainunJoft = json.SendByKainunJoft === null ? '' : json.SendByKainunJoft
          })
          .catch(error => console.log('error', error));
    },
    setShippingData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("SendByMotor", this.sendByMotor);
      urlencoded.append("IsActiveSendByMotor", this.isActiveSendByMotor);
      urlencoded.append("SendByVanetSabok", this.sendByVanetSabok);
      urlencoded.append("IsActiveSendByVanetSabok", this.isActiveSendByVanetSabok);
      urlencoded.append("SendByVanetSangin", this.sendByVanetSangin);
      urlencoded.append("IsActiveVanetSangin", this.isActiveVanetSangin);
      urlencoded.append("SendByIsuzu", this.sendByIsuzu);
      urlencoded.append("IsActiveSendByIsuzu", this.isActiveSendByIsuzu);
      urlencoded.append("SendByKhavarMamuli", this.sendByKhavarMamuli);
      urlencoded.append("IsActiveSendByKhavarMamuli", this.isActiveSendByKhavarMamuli);
      urlencoded.append("SendByKhavarBozorg", this.sendByKhavarBozorg);
      urlencoded.append("IsActiveSendByKhavarBozorg", this.isActiveSendByKhavarBozorg);
      urlencoded.append("SendByKainunMamuli", this.sendByKainunMamuli);
      urlencoded.append("IsActiveSendByKainunMamuli", this.isActiveSendByKainunMamuli);
      urlencoded.append("SendByKainunTak", this.sendByKainunTak);
      urlencoded.append("IsActiveSendByKainunTak", this.isActiveSendByKainunTak);
      urlencoded.append("SendByKainunJoft", this.sendByKainunJoft);
      urlencoded.append("IsActiveSendByKainunJoft", this.isActiveSendByKainunJoft);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "VendorPanel/VendorInformationManagement/_DefineEditTransport", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.resultText = JSON.parse(result).Message
            } else {
              this.resultText = result
            }
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    }


  }
}
</script>
